export default "__VITE_ASSET__D_UH7k8a__"